import { valibotResolver } from '@hookform/resolvers/valibot';
import { array, nonEmpty, number, object, pipe, string } from 'valibot';

export const COMMENT_FIELDS = {
  COMMENT: 'comment',
  ATTACHMENTS: 'attachments',
};

export const schemaComment = valibotResolver(
  object({
    [COMMENT_FIELDS.COMMENT]: pipe(string(), nonEmpty('This field is required.')),
    [COMMENT_FIELDS.ATTACHMENTS]: array(
      object({ path: string(), extension: string(), name: string(), size: number(), url: string() }),
    ),
  }),
);

export const commentDefaultValue = {
  [COMMENT_FIELDS.COMMENT]: '',
  [COMMENT_FIELDS.ATTACHMENTS]: [],
};
